import React from "react";

export default function Footer() {
  return (
    <div className='footer'>
      Open-source by{" "}
      <span>
        <a href='https://github.com/lkbobadi' className='github'>
          Laura Bobadilla
        </a>
      </span>
    </div>
  );
}
